import React, { useEffect } from 'react'
import { pageTitle } from '../../helper'
// import TestimonialSlider from '../Slider/TestimonialSlider'
import Cta from '../Cta'
import PageHeading from '../PageHeading'
import Div from '../Div'
import SectionHeading from '../SectionHeading'
import Spacing from '../Spacing'
import { useLocation } from 'react-router-dom';

// Helper function to create a slug from a title:
const generateSlug = (title) => {
  return title.toLowerCase().replace(/\s+/g, '-');
}

export default function ServicesPage({ serviceDetails }) {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      // Remove the '#' from the hash
      const id = location.hash.slice(1);
      const element = document.getElementById(id);
      if (element) {
        // Use scrollIntoView to scroll smoothly to the element
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);
  pageTitle('Service');
  
  useEffect(() => {
    window.scrollTo(0, 0);
    if (window.location.hash) {
      const id = window.location.hash.slice(1); // remove the '#' symbol
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, []);
  
  return (
    <>
      <PageHeading 
        title='Service Details'
        bgSrc='/images/service_hero_bg.jpg'
        pageLinkText="Services"
      />
      {serviceDetails.map((content) => {
        const sectionId = generateSlug(content.title);
        return (
          <React.Fragment key={sectionId}>
            <Spacing lg='145' md='80'/>
            {/* Add the service-section class here */}
            <Div className="container service-section" id={sectionId}>
              <SectionHeading 
                title={content.title}
                subtitle='' 
                variant='cs-style1 text-center'
              />
              <Spacing lg='90' md='45'/>
              <Div className="row">
                <div dangerouslySetInnerHTML={{ __html: content.content }} />
              </Div>
            </Div>
          </React.Fragment>
        );
      })}
      <Spacing lg='150' md='80'/>
      {/* <TestimonialSlider /> */}
      <Spacing lg='150' md='80'/>
      <Div className="container">
        <Cta 
          title='Let’s collaborate make <br />something <i>exceptional</i> together' 
          btnText='Apply For Meeting' 
          btnLink='/contact' 
          bgSrc='/images/cta_bg.jpeg'
        />
      </Div>
    </>
  )
}
